import React from 'react';
import PropTypes from 'prop-types';
import { first } from 'lodash';

import { formatFileSize } from '../../../utils/formatting';

import Alert from '../../Alert/Alert';
import { ButtonBlueLarge } from '../../Buttons/ButtonBlueLarge/ButtonBlueLarge';
import Caption from '../../Caption/Caption';
import TitleDialog from '../../TitleDialog/TitleDialog';
import Select from '../../Select/Select';

import {
    DIALOG_DOWNLOAD_ALERT,
    DIALOG_DOWNLOAD_ATTENTION,
    DIALOG_DOWNLOAD_CAPTION,
    DIALOG_DOWNLOAD_OK_BUTTON,
    DIALOG_DOWNLOAD_SELECT_CAPTION,
    DIALOG_DOWNLOAD_SELECT_CAPTION_ONE,
    DIALOG_DOWNLOAD_VERSION_VALUE,
} from './translations';

import styles from './DialogDownload.module.css';
import { getUserRole } from '../../../utils/functions';


export default class DialogDownload extends React.PureComponent {
    static propTypes = {
        isReview: PropTypes.bool,
        selectedModVersionId: PropTypes.number,
        lastGameVersionId: PropTypes.number.isRequired,
        modId: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        versions: PropTypes.arrayOf(PropTypes.shape({
            downloadUrl: PropTypes.string,
            versionFile: PropTypes.string,
            gameVersion: PropTypes.string.isRequired,
            gameVersionId: PropTypes.number.isRequired,
            id: PropTypes.number.isRequired,
            modVersion: PropTypes.string.isRequired,
            versionFileOriginalName: PropTypes.string.isRequired,
            versionFileSize: PropTypes.number,
        })),

        onSubmitDialog: PropTypes.func.isRequired,
    }

    constructor() {
        super()

        this.state = {
            gameVersionId: null,
            modVersionId: null,
            modVersion: null,
            modVersionFile: null,
            modVersionFileOriginalName: null,
            modVersionFileSize: null,
        }
    }

    componentDidMount() {
        if (this.props.isReview) {
            const selectedVersion = this.props.versions.find((item) => (item.id === this.props.selectedModVersionId))
            this.setState({
                gameVersionId: selectedVersion.gameVersionId,
                modVersionId: this.props.selectedModVersionId,
                modVersion: selectedVersion.modVersion,
                modVersionFile: selectedVersion.versionFile,
                modVersionFileOriginalName: selectedVersion.versionFileOriginalName,
                modVersionFileSize: selectedVersion.versionFileSize,
            })
        } else {
            const lastModVersion = first(this.props.versions)
            this.setState({
                gameVersionId: lastModVersion.gameVersionId,
                modVersionId: lastModVersion.id,
                modVersion: lastModVersion.modVersion,
                modVersionFile: lastModVersion.downloadUrl,
                modVersionFileOriginalName: lastModVersion.versionFileOriginalName,
                modVersionFileSize: lastModVersion.versionFileSize,
            })
        }
    }

    handleModVersionChange = (modVersionId) => {
        const selectedVersion = this.props.versions.find((item) => (item.id === modVersionId))
        this.setState({
            modVersionId,
            modVersion: selectedVersion.modVersion,
            gameVersionId: selectedVersion.gameVersionId,
            modVersionFile: selectedVersion.downloadUrl,
            modVersionFileOriginalName: selectedVersion.versionFileOriginalName,
            modVersionFileSize: selectedVersion.versionFileSize,
        })
    }

    handleDownloadClick = () => {
        this._downloadLinkRef.click()
        this.props.onSubmitDialog(this.props.modId)
    }

    renderAlert() {
        return this.state.gameVersionId !== this.props.lastGameVersionId ? (
            <Alert content={DIALOG_DOWNLOAD_ALERT} />
        ) : null
    }

    renderVirusTotalLink = () => {
        if (getUserRole() === 'admin' || getUserRole() === 'moderator' || getUserRole() === 'robot') {
            if (this.state.modVersionFile !== null) {
                let url = this.state.modVersionFile.replace(/\//g, '%252F').replace(/:/g, '%253A') || null
                
                return (
                    <p className={styles.attention}>
                        VirusTotal: 
                        <br />
                        <a href={'https://virustotal.com/gui/search/'+url} rel="noreferrer" target="_blank">{this.state.modVersionFile}</a>
                    </p>
                )
            } else {
                return 
            }
        } else {
            return
        }
    }

    render() {
        let itemsForSelect = [];
        if (!this.props.isReview) {
            itemsForSelect = this.props.versions.map((item) => ({
                caption: DIALOG_DOWNLOAD_VERSION_VALUE(item.modVersion, item.gameVersion),
                value: item.id,
            }))
        } else {
            let ggVersion, ggVerId, ggVer
            if (this.state.gameVersionId) {
                ggVersion = window.__SETTINGS__.gameVersions.find((item) => (item.id === this.state.gameVersionId)).version
                ggVer = this.state.modVersion
                ggVerId = this.state.modVersionId
            } else {
                ggVersion = ''
                ggVerId = 0
                ggVer = ''
            }
            
            itemsForSelect = [{
                caption: DIALOG_DOWNLOAD_VERSION_VALUE(ggVer, ggVersion),
                value: ggVerId,
            }]
        }

        return (
            <div className={styles.base}>
                <TitleDialog>
                    <span title={this.props.title}>
                        {DIALOG_DOWNLOAD_CAPTION(this.props.title)}
                    </span>
                </TitleDialog>
                {this.renderVirusTotalLink()}
                <div className={styles.modVersion}>
                    <Caption>{this.props.isReview ? DIALOG_DOWNLOAD_SELECT_CAPTION_ONE : DIALOG_DOWNLOAD_SELECT_CAPTION}</Caption>
                    <div className={styles.select}>
                        <Select
                            gtmTag={'ev_click-change-version'}
                            items={itemsForSelect}
                            selectedValue={this.state.modVersionId}
                            isDisabled={itemsForSelect.length === 1}
                            onItemChange={this.handleModVersionChange}
                        />
                    </div>
                </div>
                {this.renderAlert()}
                <hr className={styles.hr} />
                <p className={styles.attention}>{DIALOG_DOWNLOAD_ATTENTION}</p>
                <ButtonBlueLarge onClick={this.handleDownloadClick} gtmTag={'ev_click-download2'}>
                    {DIALOG_DOWNLOAD_OK_BUTTON(formatFileSize(this.state.modVersionFileSize))}
                </ButtonBlueLarge>
                <a
                    className={styles.hidden}
                    ref={c => (this._downloadLinkRef = c)}
                    href={this.state.modVersionFile}
                    download={this.state.modVersionFileOriginalName}
                > </a>
            </div>
        )
    }
}
